import { IRestColumnProps } from "components/rest/Table/TableColumn";
import RestList from "containers/rest/List";
import { useTranslation } from "react-i18next";
import { DynamicObjectType, FilterFromUrlResponseType } from "types/commons";

const SEARCH_KEYS = ['variantSku'];

const breadcrumbs = [
   {
     title: 'common.page.settings',
     href: '/settings',
   },
   {
      title: 'common.page.variantRelated',
   },
];

const columns: IRestColumnProps[] = [
   {
      name: 'variantSku',
      title: 'Original sku',
      isDefault: true,
   },
   {
      name: 'productVariantRelateds',
      title: 'NEW SKU',
      render: (data: DynamicObjectType[]) => (
         <div>
            {data?.map((item) => item?.relatedVariantSku)?.join(', ')}
         </div>
      ),
      isDefault: true,
    },
];

const initialFilter: FilterFromUrlResponseType = {
   filters: [
     {
       condition: 'and',
       key: 'productVariantRelateds.id',
       operator: 'notnull',
       value: "true",
     },
   ],
 };

export default function RelatedSKUsList() {
   const { t } = useTranslation();
   return (
      <RestList
         hasExport={false}
         hasImport={false}
         hasEdit
         hasShow={false}
         columns={columns}
         breadcrumbs={breadcrumbs}
         model="variantRelated"
         rowSelectionActions={<></>}
         // formatListData={formatListData}
         initialFilter={initialFilter}
         searchKeys={SEARCH_KEYS}
         placeholderInputSearch={t('settings.sku.placeholderSearch')}
   />
   )
}